import { PURCHASE_ORDER_STATUS, type PurchaseOrderStatus } from "@stocks/shared";

export const ORDER_STATUS_LABELS: Record<PurchaseOrderStatus, string> = {
  [PURCHASE_ORDER_STATUS.OPEN]: "진행 중",
  [PURCHASE_ORDER_STATUS.CANCELLED]: "취소",
};
